import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
export interface GoogleConfig {
  googleClientId: string;
}

@Injectable({
  providedIn: 'root'
})
export class ConfigGoogleService {
   private appConfig: GoogleConfig | undefined;

  
  constructor(private http: HttpClient,
    private ecryptService: EcryptServiceService 
  ) { }

  // This method is called by the APP_INITIALIZER.
  // IMPORTANT: Always resolves immediately — app startup is never blocked by this API call.
  loadAppConfig() {
    // Step 1: Load from cache instantly (if available) so the app renders right away
    const cachedConfig = localStorage.getItem('googleAppConfigCache');
    if (cachedConfig) {
      try {
        this.appConfig = JSON.parse(cachedConfig);
      } catch (e) { /* ignore malformed cache */ }
    }

    // Step 2: Always fetch fresh config from the server in the background (fire-and-forget)
    this.http.get<GoogleConfig>(environment.serverAPI4 + '/api/ig/config/new')
      .toPromise()
      .then((response: any) => {
        if (!response) return;
        let configData = response;
        if (response.encryptedText != null) {
          const decrypted = this.ecryptService.decryptionAES(response.encryptedText);
          configData = JSON.parse(decrypted);
        }
        this.appConfig = configData;
        localStorage.setItem('googleAppConfigCache', JSON.stringify(configData));
      })
      .catch(err => console.error('[ConfigGoogleService] Background config refresh failed:', err));

    // Step 3: Always return immediately — never block the app
    return Promise.resolve();
  }

  // Getter to provide the loaded client ID
  get googleClientId(): string {
    return this.appConfig?.['apiKey'] || '';
  }
}

